import { transitionDuration, transitionFunction } from 'globals/styles';

const styles = {
  icon: {
    cursor: 'pointer',
    position: 'fixed',
    bottom: '25px',
    right: '25px',
    width: '50px',
    height: '50px',
    pointerEvents: 'all',
    '@media (max-width: 600px)': {
      right: '10px',
      bottom: '10px',
    },
    WebkitFilter: 'drop-shadow(1px 1px 4px rgba(0,0,0,.33))',
    filter: 'drop-shadow(1px 1px 4px rgba(0,0,0,.33))',
    WebkitTransition: 'all .2s ease-in-out',
    transition: `all ${transitionDuration} ${transitionFunction}`,
    WebkitPerspective: 1000,
    WebkitBackfaceVisibility: 'hidden',
    ':hover': {
      WebkitTransform: 'translateY(-5px) scale(1.05)',
      transform: 'translateY(-5px) scale(1.05)',
      WebkitFilter: 'drop-shadow(1px 1px 6px rgba(0,0,0,.33))',
      filter: 'drop-shadow(1px 1px 6px rgba(0,0,0,.33))',
    },
  },
};

export default styles;
